<template>
    <!--PC详情页-->
    <!-- 导航栏 -->
    <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>
    <!-- 导航栏 -->
    <!-- 主体内容容器 -->
    <div class="container errong">
        <div class="container-fluid p-0 my-2"></div>
        <div class="row gx-2">
            <!-- 左侧部分 -->
            <div class="col-lg-8">
                <div class="LeftPart">
                    <div class="row pp shengse pb-3 pt-1">
                        <div><span class="Title">{{ details.name }}</span></div>
                        <div class="ri mb-1">
                            <small class="bi bi-clock zitipc" id=""><span>&nbsp;{{ details.createTime.substr(0, 10) }}&nbsp;&nbsp;</span></small>
                            <small class="bi bi-person-fill zitipc" id="collect"><span>&nbsp;匿名</span></small>
                        </div>
                        <div class="daxiao">
                            <div class="py-1 jiushi"><span class="jiacu">所属地区：</span>&nbsp;{{ details.province }}-{{ details.city }}</div>
                            <div class="py-1 jiushi"><span class="jiacu">小姐年龄：</span>&nbsp;{{ details.age }}</div>
                            <div class="py-1 jiushi"><span class="jiacu">小姐颜值：</span>&nbsp;{{ details.level }}</div>
                            <div class="py-1 jiushi"><span class="jiacu">消费水平：</span>&nbsp;{{ details.price }}</div>
                            <div class="py-1 jiushi"><span class="jiacu">服务项目：</span>&nbsp;{{ details.condition }}</div>
                            <div class="mt-2">
                                <!-- 收藏按钮 -->
                                <button type="button" @click="toggleCollect" class="btn btn-outline-success bi-bag-heart jiushi me-2 button-large">
                                    {{ isCollected ? '已收藏' : '收藏' }}
                                </button>
                                <!-- 申请删除按钮 -->
                                <button type="button" @click="applyDel" class="btn btn-outline-success bi-trash3 jiushi button-large" data-bs-toggle="modal" data-bs-target="#myModal2">申请删除</button>
                            </div>
                        </div>
                    </div>

                    <!--商品-->
                    <div class="row shengse mt-2 rounded-top-1">
                        <div class="dixian px-4 py-2 d-flex justify-content-between">
                            <div><i class="shou bi bi-telephone-fill"></i>商品</div>
                            <div class="iden">
                                <a class="text-decoration-none ruhe zitiyanse hover-hand" @click="showModalInfo('myModal5')">如何鉴别？</a>
                            </div>
                        </div>
                    </div>
                    <!--商品-->
                    <!--如何鉴别-->
                    <div class="row shengse pt-4 pb-0">
                        <div class="px-4">
                            <div>
                                <div class="alert alert-warning zhuzi" role="alert">凡是有要求路费/定金/保证金/照片验证/视频验证等任何提前付费的行为，千万不要上当。同时也请注意仙人跳，在寻欢前不要露富和带过于贵重随身物品。本站为分享信息并不对寻欢经历负责，碰到有问题的信息，请及时举报给我们删除信息。部分小姐姐较为敏感，所以请在联系对方时不要透露此条信息来源。
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--如何鉴别-->
                    <!--账号-->
                    <div class="row shengse pb-4 rounded-bottom-1">
                        <div class="px-4">
                            <template v-if="!isLoggedIn">
                                <div class="py-1 jiushi"><span class="jiacu">QQ：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                                <div class="py-1 jiushi"><span class="jiacu">微信：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                                <div class="py-1 jiushi"><span class="jiacu">与你号：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                                <div class="py-1 jiushi"><span class="jiacu">Telegram：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                                <div class="py-1 jiushi"><span class="jiacu">电话：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                                <div class="py-1 jiushi"><span class="jiacu">地址：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                            </template>
                            <template v-else-if="vipExpired">
                                <div class="py-1 jiushi"><span class="jiacu">QQ：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                                <div class="py-1 jiushi"><span class="jiacu">微信：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                                <div class="py-1 jiushi"><span class="jiacu">与你号：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                                <div class="py-1 jiushi"><span class="jiacu">Telegram：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                                <div class="py-1 jiushi"><span class="jiacu">电话：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                                <div class="py-1 jiushi"><span class="jiacu">地址：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                            </template>
                            <template v-else>
                                <div v-if="details.account" class="py-1 jiushi"><span class="jiacu">QQ：</span>&nbsp;{{ details.account }}</div>
                                <div v-if="details.remark" class="py-1 jiushi"><span class="jiacu">微信：</span>&nbsp;{{ details.remark }}</div>
                                <div v-if="details.email" class="py-1 jiushi"><span class="jiacu">与你号：</span>&nbsp;{{ details.email }}</div>
                                <div v-if="details.attention" class="py-1 jiushi"><span class="jiacu">Telegram：</span>&nbsp;{{ details.attention }}</div>
                                <div v-if="details.phone" class="py-1 jiushi"><span class="jiacu">电话：</span>&nbsp;{{ details.phone }}</div>
                                <div v-if="details.source" class="py-1 jiushi"><span class="jiacu">地址：</span>&nbsp;{{ details.source }}</div>
                            </template>
                            <div class="py-1 zhuzi">
                                <span style="color:red">！！！警告：凡是需要预先支付定金、路费的都是诈骗！任何情况下，都不要先给钱！</span>
                            </div>
                            <div class="mt-2">
                                <!-- 防骗指南按钮 -->
                                <button data-bs-toggle="modal" data-bs-target="#myModal4" type="button" href="" class="btn btn-outline-success bi-eye button-large">防骗指南</button>
                                <!-- 信息规则按钮 -->
                                <button data-bs-toggle="modal" data-bs-target="#myModal3" type="button" href="" class="btn btn-outline-success bi-info-circle button-large">信息规则</button>
                            </div>
                        </div>
                    </div>

                    <!--账号-->
                    <!--详细介绍-->
                    <div class="row shengse mt-2 rounded-top-1">
                        <div class="dixian px-4 py-2 d-flex justify-content-between">
                            <div class="deziti"><i class="shou bi bi-info-circle"></i>详细介绍</div>
                        </div>
                    </div>
                    <!--详细介绍-->
                    <!--截图-->
                    <div class="row shengse pb-4 rounded-bottom-1">
                        <div class="d-flex flex-wrap" ref="gallery">
                            <div class="p-2"
                                 v-for="(img, index) in imgList"
                                 :key="index"
                                 style="flex: 0 0 25%; max-width: 25%;">
                                <img class="Img w-100 clickable-img" :src="img" alt="图片预览" />
                            </div>

                            <div class="px-3 pb-3 mt-3">
                                <p class="mb-2 indented" style="font-size: 0.9rem;">
                                    {{ details.history }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--截图-->

                    <!--用户反馈-->
                    <div class="row shengse mt-2 rounded-bottom-1 rounded-top-1">
                        <div class="dixian px-4 py-2 mb-3 d-flex justify-content-between">
                            <div class="deziti"><i class="shou bi bi-chat-dots-fill"></i>狼友反馈</div>
                        </div>
                        <ZhaiCommentPC v-for="(feedback, index) in feedbackList" :key="index" :data="feedback"></ZhaiCommentPC>
                        <div class="fk-ad">
                            <!-- 我要反馈按钮 -->
                            <button type="button" @click="checkLoginBeforeFeedback" class="btn btn-outline-success mx-auto bi-file-plus-fill button-large">我要反馈</button>
                        </div>
                    </div>
                    <!--用户反馈-->
                </div>
            </div>
            <!-- 右侧推荐部分 -->
            <div class="col-lg-4">
                <div class="RightPart">
                    <div class="bdcard">
                        <div class="row rr mt-4">
                            <div class="deziti zuo px-4 pb-2 d-flex justify-content-between">
                                <div><i class="shou bi bi-geo-alt-fill"></i>本地其他推荐</div>
                            </div>
                            <div v-for="(item, index) in recommendList" :key="index" class="no-underline mb-1">
                                <ZhaiCardPC :data="item" @click="updateRoute(item.id)"></ZhaiCardPC>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 主体内容容器 -->

    <!-- 只是占据空间 -->
    <div class="gongxi2"></div>

    <!-- 公共底部 -->
    <ZhaiFootPC></ZhaiFootPC>
    <!-- 我要反馈 模态框 -->
    <div class="modal fade" id="myModal">
        <div class="modal-dialog modal-dialog-centered feedback-modal">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title motou">我要反馈</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="ant-modal-body mb-2 mt-1">
                    <form class="myform px-3">
                        <div class="form-group mt-3 ">
                            <label style="font-size:1rem;">反馈信息：</label>
                            <input style="font-size:1rem;" type="text" id="feedback-info" class="form-control" v-model="feedbackInfo" name="feedback-info" placeholder="" readonly>
                        </div>
                        <div class="form-group mt-4">
                            <label style="font-size:1rem;">反馈内容：</label>
                            <textarea class="form-control " id="content" v-model="feedbackContent" placeholder="平台鼓励反馈真实的体验，请勿提交违背事实的虚假反馈，一经发现将关闭你的评论权限，情节严重的将可能直接封号。"></textarea>
                        </div>
                        <div class="form-group mt-4 px-2">
                            <label style="font-size:1rem;">验证码：</label>
                            <div style="max-width: 300px;">
                                <!-- 这里是包裹验证码输入框的 div -->
                                <CaptchaComponent ref="captchaComponent" @validate-captcha="validateCaptcha"></CaptchaComponent>
                            </div>
                        </div>
                        <div class="form-group mt-3">
                            <div class="text-center mb-3">
                                <button type="button" @click="submitFeedback" class="btn btn-success px-5 toushu feedback-submit-btn button-large2">提交</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!--申请删除  模态框 -->
    <div class="modal fade" id="myModal2">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title motou">申请删除</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body">
                    <div class="ant-modal-body motou px-3">
                        <div>本站所有內容来自网友分享，如有内容侵犯到你的隐私、权益或未经你的允许而被他人发布，平台很愿意为你删除，我们同样憎恶出于报复他人的目的而发布的内容。请你提供相关证明材料（比如与帖子内容相符的生活照、或你在其他社交平台发布的链接等，或可以证明联系方式确属于你的证明材料）发邮件至yufenglou123@gmail.com，我们通常会在24小时内处理你的请求，最长不会超过48小时，如果事实逻辑清晰我们将及时为你删除。</div>
                    </div>
                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer di text-center">
                    <button type="button" class="btn btn-success toushu d-block mx-auto button-large2" data-bs-dismiss="modal">关闭</button>
                </div>
            </div>
        </div>
    </div>
    <!--信息规则 模态框 -->
    <div class="modal fade" id="myModal3">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title motou">信息规则</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body motou px-3">
                    <div>部分信息会隐藏具体地址和联系方式，需要升级VIP会员来享受无限制查看信息的权限。
                    </div>
                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer di text-center">
                    <button type="button" class="btn btn-success toushu d-block mx-auto button-large2" data-bs-dismiss="modal">关闭</button>
                </div>
            </div>
        </div>
    </div>
    <!--防骗 模态框 -->
    <div class="modal fade" id="myModal4">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="margin-top: 380px;">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title motou">防骗指南</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body p-2">
                    <p class="px-3 fb" style="margin-bottom: 0!important;">大家做到以下几点，基本可以有效避免上当受骗。</p>
                    <p class="px-3 fb">防骗第一条：凡是要求预付定金/保证金的，都是骗子！</p>
                    <p class="px-3 motou">
                        一、如果妹子是自己租公寓或者小区里的房子，打听一下房子的租金就可以知道妹子做这个生意的成本大概是多少，依据这个可判断是不是坑。不熟悉的妹子千万不要选择上门，因为没有自己承租地方做这个生意的，大概率都是骗子。
                    </p>
                    <p class="px-3 motou">
                        二、未见面，拒绝提前支付任何费用！！！如车费、定金、安全保证金、预付一半费用、付全款后才见面等各种理由的费用（如给红包发照片，给红包视频，定位到楼下付款，其他人代收款等），切勿因为已开房或其他费用，因小失大，不停给对方打款，越陷越深。
                    </p>
                    <p class="px-3 motou">
                        三、见面后，确认为所预约的人，付费给妹子，或当着妹子的面付给中间人，付费后禁止对方以任何理由离开房间，如有必要离开，请随行，或要求对方退款后，方可离开。
                    </p>
                    <p class="px-3 motou">
                        四、见面后，人照不符的，不满意的，可以拒绝接受服务，或给车费让他走。如是平台认证的帖子，差距大的，不满意的，请立即联系管理员处理。并及时联系平台在线客服。
                    </p>
                    <p class="px-3 motou">
                        五、到店服务的，和描述不一致，直接离开。进店后，问清楚服务项目。确认有服务，选到满意技师，再交费或服务后再交费。模糊介绍服务，为选人先交费，要求办卡才有服务的，请立即离开，并联系平台反馈。
                    </p>
                    <p class="px-3 motou">
                        六、可以提前百度一下对方的联系方式，看是否有人曾被骗。
                    </p>
                    <p class="px-3 motou">
                        七、拒绝支付任何平台旗号的费用。
                    </p>

                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer di text-center">
                    <button type="button" class="btn btn-success toushu d-block mx-auto button-large2" data-bs-dismiss="modal">关闭</button>
                </div>
            </div>
        </div>
    </div>
    <!--如何鉴别 模态框 -->
    <div class="modal fade" id="myModal5">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title">如何鉴别</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body p-2">
                    当您对账号的质量有所顾虑的时候，建议您先购买季度会员，找到适合您的账号并且感觉
                    本站产品的质量可以的情况下再进行VIP升级；
                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer mt-2 text-center" style="display: block;">
                    <div class="row">
                        <div class="col-6">
                            <button type="button" class="btn btn-success toushu button-large" data-bs-dismiss="modal">关闭</button>
                        </div>
                        <div class="col-6">
                            <button
                                    type="button"
                                    class="btn btn-success toushu button-large2"
                                    @click="handleNavigateToAvoidFraud">
                                新手防骗指南
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 登录警示 模态框 -->
    <div class="modal fade" id="loginWarningModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="width: 150px;">
            <div class="modal-content">
                <div class="modal-body text-center d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-frown" style="font-size: 2rem; color: #f16b6b;"></i>
                    <p class="mb-0 ms-2" style="font-size: 1rem; color: #f16b6b;">请先登录！</p>
                </div>
            </div>
        </div>
    </div>
    <!-- 成功模态框 -->
    <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 200px;">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-smile" style="font-size: 2rem; color: #00c26f;"></i>
                    <p class="mb-0 ms-2" style="font-size: 1rem; color: #00c26f;"></p>
                </div>
            </div>
        </div>
    </div>

    <!-- 失败模态框 -->
    <div class="modal fade" id="generalErrorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-shake" style="max-width: 200px;">
            <div class="modal-content shake">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-frown" style="font-size: 2rem; color: #dc3545;"></i>
                    <p class="mb-0 ms-2" style="font-size: 1rem; color: #dc3545;"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Viewer from 'viewerjs';
    import 'viewerjs/dist/viewer.css';
    import { Modal } from 'bootstrap';
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import ZhaiCardPC from "../componentspc/ZhaiCardPC";
    import ZhaiCommentPC from "../componentspc/ZhaiCommentPC";
    import CaptchaComponent from "../componentspc/CaptchaComponent.vue";
    import http from "../utils/http.js";
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "PDetails",
        components: {
            ZhaiHeadPC,
            ZhaiFootPC,
            ZhaiCardPC,
            ZhaiCommentPC,
            CaptchaComponent
        },
        props: ['id'],
        data() {
            return {
                feedbackInfo: '',
                feedbackContent: '',
                details: {
                    name: '',
                    uploadDate: '',
                    collection: '',
                    province: '',
                    city: '',
                    age: '',
                    price: '',
                    level: '',
                    condition: '',
                    account: '',
                    remark: '',
                    email: '',
                    attention: '',
                    phone: '',
                    source: '',
                    img: '',
                    createTime: '',
                    history: '',
                    presets3: '',
                    presets4: '',
                    presets5: ''
                },
                imgList: [],
                recommendList: [],
                feedbackList: [],
                isCollected: false,
                viewerInstance: null
            };
        },
        computed: {
            ...mapGetters(['isLoggedIn', 'getUser']),

            // ✅ 最终版：VIP 是否过期
            vipExpired() {
                // 未登录：不判断 VIP（走“请先登录/注册”分支）
                if (!this.isLoggedIn) return false;

                // ⚠️ 关键：user 还没拿到时，先不要判过期（否则首屏永远显示升级VIP）
                if (!this.getUser) return false;

                const raw =
                    this.getUser.level_expire_date ??
                    this.getUser.levelExpireDate ??
                    this.getUser.level_expireDate ??
                    null;

                // 没有过期时间：按过期处理（你业务若相反，就改成 false）
                if (raw === null || raw === undefined) return true;

                const trimmed = String(raw).trim();
                if (trimmed === "" || trimmed === "null" || trimmed === "undefined") return true;

                // 1) 纯数字：时间戳（秒/毫秒都兼容）
                if (!Number.isNaN(Number(trimmed))) {
                    const n = Number(trimmed);
                    const ms = String(Math.trunc(n)).length === 10 ? n * 1000 : n;
                    return ms < Date.now();
                }

                // 2) 字符串时间：修复 +0800 → +08:00
                let s = trimmed;

                // Safari/部分浏览器兼容：空格转 T
                s = s.replace(' ', 'T');

                // 修复尾部时区：+0800 / -0530 这种 → +08:00 / -05:30
                s = s.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');

                // 只有日期：默认当天 23:59:59
                if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                    s += 'T23:59:59';
                }

                const d = new Date(s);
                const ms = d.getTime();
                if (Number.isNaN(ms)) {
                    console.warn('VIP expire date parse failed:', raw, 'normalized=', s);
                    return true;
                }

                return ms < Date.now();
            }
        },

        async created() {
            // ✅ 关键：先等 store 把 user 补齐（避免首屏误判 vipExpired）
            await this.checkLoginStatus();

            this.fetchDetails();
            this.fetchFeedbackList();
            this.checkCollectStatus();
        },

        mounted() {
            this.initViewer();
        },

        watch: {
            imgList() {
                this.initViewer();
            },
            '$route.query.id'() {
                this.fetchDetails();
                this.fetchFeedbackList();
            }
        },

        methods: {
            ...mapActions(['logout', 'checkLoginStatus']),

            handleNavigateToAvoidFraud() {
                const modal5 = document.getElementById('myModal5');
                if (modal5) {
                    const modalInstance = Modal.getInstance(modal5);
                    if (modalInstance) modalInstance.hide();

                    document.body.classList.remove('modal-open');
                    const backdrops = document.getElementsByClassName('modal-backdrop');
                    while (backdrops.length > 0) {
                        backdrops[0].parentNode.removeChild(backdrops[0]);
                    }
                }
                this.$nextTick(() => {
                    this.$router.push('/avoidFraud');
                });
            },

            updateRoute(id) {
                this.$router.push({ query: { id } });
            },

            showModalInfo(modalId) {
                const modalElement = document.getElementById(modalId);
                if (modalElement) {
                    const modal = new Modal(modalElement);
                    modal.show();
                }
            },

            applyDel() {
                console.log('申请删除按钮被点击');
            },

            checkCollectStatus() {
                if (!this.isLoggedIn || !this.getUser?.id) return;

                const id = this.$route.query.id;
                const userId = this.getUser.id;

                const postData = {
                    accountid: id,
                    userid: userId,
                    action: 'check'
                };

                http.post('/platform/frontEnd/handleCollect', postData)
                    .then(response => {
                        if (response.data.status === 1) {
                            this.isCollected = response.data.data.isCollected;
                        } else {
                            console.error('检查收藏状态失败:', response.data.msg);
                        }
                    })
                    .catch(error => {
                        console.error('检查收藏状态时出错:', error);
                    });
            },

            toggleCollect() {
                if (!this.isLoggedIn) {
                    const warningModalElement = document.getElementById('loginWarningModal');
                    const warningModal = new Modal(warningModalElement);

                    if (warningModalElement.classList.contains('show')) {
                        warningModalElement.classList.remove('shake-animation');
                        void warningModalElement.offsetWidth;
                        warningModalElement.classList.add('shake-animation');
                    } else {
                        warningModalElement.classList.add('shake-animation');
                        warningModal.show();
                        setTimeout(() => warningModal.hide(), 2000);
                        setTimeout(() => warningModalElement.classList.remove('shake-animation'), 600);
                    }
                    return;
                }

                const accountId = this.details.id;
                const userId = this.getUser.id;
                const action = this.isCollected ? 'cancel' : 'collect';

                if (!userId || !accountId) return;

                const postData = {
                    accountid: accountId,
                    userid: userId,
                    action
                };

                http.post('/platform/frontEnd/handleCollect', postData)
                    .then(response => {
                        if (response.data && response.data.status === 1) {
                            this.isCollected = !this.isCollected;
                            this.showModal(
                                'successModal',
                                this.isCollected ? '收藏成功' : '取消收藏成功',
                                'bi bi-emoji-smile',
                                '#00c26f'
                            );
                        } else {
                            this.showModal(
                                'generalErrorModal',
                                action === 'collect' ? '收藏失败' : '取消收藏失败',
                                'bi bi-emoji-frown',
                                '#dc3545'
                            );
                        }
                    })
                    .catch(error => {
                        console.error(`${action === 'collect' ? '收藏' : '取消收藏'}请求错误:`, error);
                        this.showModal('generalErrorModal', '请求发生错误，请稍后再试', 'bi bi-emoji-frown', '#dc3545');
                    });
            },

            submitFeedback() {
                const codeInput = document.querySelector('.captcha-input');
                const enteredCaptcha = codeInput ? codeInput.value.trim() : '';
                const actualCaptcha = this.$refs.captchaComponent.captchaText;

                if (!this.feedbackContent || !this.feedbackContent.trim()) {
                    this.showModal('generalErrorModal', '必填项不可为空！', 'bi bi-emoji-frown', '#dc3545');
                    return;
                }

                if (!enteredCaptcha) {
                    this.showModal('generalErrorModal', '必填项不可为空！', 'bi bi-emoji-frown', '#dc3545');
                    return;
                }

                if (enteredCaptcha !== actualCaptcha) {
                    this.showModal('generalErrorModal', '验证码错误！', 'bi bi-emoji-frown', '#dc3545');
                    this.$refs.captchaComponent.generateCaptcha();
                    return;
                }

                const feedbackData = {
                    message: this.feedbackContent,
                    accountid: this.details.id,
                    userid: this.getUser.id,
                    username: this.getUser.username,
                    userlevel: this.getUser.level || 'defaultLevel'
                };

                http.post('/platform/frontEnd/feedback', feedbackData, false, true)
                    .then(response => {
                        if (response.data.status === 1) {
                            this.showModal('successModal', '反馈提交成功', 'bi bi-emoji-smile', '#00c26f');
                            const feedbackModal = Modal.getInstance(document.getElementById('myModal'));
                            feedbackModal.hide();
                        } else {
                            this.showModal('generalErrorModal', `反馈提交失败: ${response.data.msg}`, 'bi bi-emoji-frown', '#dc3545');
                        }
                    })
                    .catch(error => {
                        console.error(`提交反馈时出错: ${error}`);
                        this.showModal('generalErrorModal', `请求发生错误: ${error.response?.data?.msg || '未知错误'}`, 'bi bi-emoji-frown', '#dc3545');
                    });
            },

            showModal(modalId, message, iconClass, textColor) {
                const modalElement = document.getElementById(modalId);
                const modalBodyP = modalElement.querySelector('.modal-body p');
                const icon = modalElement.querySelector('.bi');

                icon.className = iconClass;
                icon.style.color = textColor;
                modalBodyP.textContent = message;

                const modal = new Modal(modalElement);
                modalElement.classList.add('shake-animation');
                modal.show();

                setTimeout(() => {
                    modalElement.classList.remove('shake-animation');
                    modal.hide();
                }, 3000);
            },

            checkLoginBeforeFeedback() {
                const warningModalElement = document.getElementById('loginWarningModal');
                const warningModal = new Modal(warningModalElement);

                if (this.isLoggedIn) {
                    const feedbackModal = new Modal(document.getElementById('myModal'));
                    feedbackModal.show();
                } else {
                    if (warningModalElement.classList.contains('show')) {
                        warningModalElement.classList.remove('shake-animation');
                        void warningModalElement.offsetWidth;
                        warningModalElement.classList.add('shake-animation');
                    } else {
                        warningModalElement.classList.add('shake-animation');
                        warningModal.show();
                        setTimeout(() => warningModal.hide(), 2000);
                        setTimeout(() => warningModalElement.classList.remove('shake-animation'), 600);
                    }
                }
            },

            validateCaptcha(isValid) {
                if (!isValid) {
                    alert('图形验证码输入不正确！');
                }
            },

            initViewer() {
                this.$nextTick(() => {
                    const gallery = this.$refs.gallery;
                    if (gallery) {
                        if (this.viewerInstance) this.viewerInstance.destroy();
                        this.viewerInstance = new Viewer(gallery, {
                            url(image) {
                                return image.src;
                            }
                        });
                    }
                });
            },

            fetchDetails() {
                const id = this.$route.query.id;
                if (!id) return;

                http.get(`/platform/frontEnd/details?id=${id}`)
                    .then(response => {
                        if (response.data.status === 1) {
                            this.details = response.data.data;
                            this.feedbackInfo = this.details.name;

                            this.imgList = [
                                ...(this.details.img ? this.details.img.split(',').map(v => v.trim()) : []),
                                ...(this.details.presets3 ? this.details.presets3.split(',').map(v => v.trim()) : []),
                                ...(this.details.presets4 ? this.details.presets4.split(',').map(v => v.trim()) : []),
                                ...(this.details.presets5 ? this.details.presets5.split(',').map(v => v.trim()) : [])
                            ];

                            this.checkCollectStatus();
                            this.fetchRecommendList(this.details.id);
                        } else {
                            console.error('获取详情数据失败:', response.data.msg);
                        }
                    })
                    .catch(error => {
                        console.error('获取详情数据时出错:', error);
                    });
            },

            fetchRecommendList(id) {
                if (!id) return;

                http.get(`/platform/frontEnd/recommendList?id=${id}`)
                    .then(response => {
                        if (response.data.status === 1) {
                            this.recommendList = response.data.data || [];
                        } else {
                            console.error('获取推荐列表失败:', response.data.msg);
                        }
                    })
                    .catch(error => {
                        console.error('获取推荐列表时出错:', error);
                    });
            },

            fetchFeedbackList() {
                const id = this.$route.query.id;

                http.get(`/platform/frontEnd/feedbackAccountid?feedbackAccountid=${id}`)
                    .then(response => {
                        if (response.data.status === 1) {
                            this.feedbackList = response.data.data || [];
                        } else {
                            console.error('获取用户反馈数据失败:', response.data.msg);
                        }
                    })
                    .catch(error => {
                        console.error('获取用户反馈数据时出错:', error);
                    });
            }
        }
    };
</script>

<style scoped>
    .fb{
        font-weight: bold;
        color: #00c26f

    }
    .motou{
        font-size: 1rem!important;
    }
    .gongxi2 {
        height: 20px;
    }

    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    .card-body > p {
        margin-bottom: 0 !important;
    }

    .container {
        padding-left: 20px;
        padding-right: 20px;
    }

    .LeftPart {
        margin-top: 10px;
    }

    /*模态框按钮颜色以及去边框*/
    .toushu {
        background-color: #00c26f !important;
        border: none !important;
    }

    .btn {
        font-size: 0.6rem;
        padding: 0.2rem 0.5rem;
        line-height: 1.5;
    }

    .btn-outline-success {
        color: #00c26f;
        border-color: #00c26f;
    }

    .feedback-submit-btn {
        line-height: 2.0;
        font-size: 0.9rem !important;
    }

    .me-2 {
        margin-right: 0.5rem;
    }

    .pp {
        padding-left: 0.8rem !important;
        padding-right: 0 !important;
        border-radius: 2px;
    }

    .col-lg-4 {
        margin-left: 20px;
    }

    .col-lg-8 {
        width: calc(100% - 20px - 33.333333%);
    }

    .zuo {
        padding-left: 10px !important;
    }

    .shou {
        font-style: normal;
    }

    .zhuzi {
        font-size: 0.8rem;
    }

    .jiushi {
        font-size: 0.9rem;
    }

    .indented {
        text-indent: 2em;
    }

    .fk-ad {
        text-align: center;
        padding-bottom: 2rem;
    }

    .bi-bag-heart {
        margin-right: 5px;
    }

    .bi-eye {
        margin-right: 5px;
    }

    .ruhe {
        font-size: 0.6rem;
    }

    .bi-telephone-fill {
        font-size: 10px;
    }

    h4 {
        font-size: 0.8rem !important;
    }
     /*模态框输入框里字体大小*/
    .form-control {
        font-size: 1rem !important;
    }

    .qing {
        padding-left: 0 !important;
    }

    .code-input {
        width: 110px;
    }

    .modal-dialog {
        width: 40%;
        max-height: 50%;
        margin: auto;
    }

    .modal-body {
        padding: 0;
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem;
        border-bottom: 1px solid #dee2e6;
    }

    .modal-content {
        position: relative;
        background-color: white;
        border: 1px solid #dee2e6;
        margin: auto;
    }

    .modal-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: transform 0.2s ease;
        cursor: grab;
    }

    .modal-image:active {
        cursor: grabbing;
    }

    .outside-close {
        position: fixed;
        top: 10px;
        right: 10px;
        background-color: rgba(255, 255, 255, 0.3);
        border: none;
        font-size: 1rem;
        cursor: pointer;
        z-index: 1051;
        opacity: 0.7;
    }

    .outside-close:hover {
        opacity: 1;
    }

    .modal-controls {
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 10px;
        z-index: 1051;
    }

    .btn-control {
        background-color: transparent;
        border: none;
        font-size: 1.5rem;
        opacity: 0.7;
        color: white;
    }

    .btn-control:hover {
        opacity: 1;
    }

    .rounded-top-2 {
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
    }

    .rounded-bottom-2 {
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
    }

    .login-register-link {
        color: #18b371 !important;
        font-size: inherit;
        text-decoration: none;
        padding: 0;
    }

    .login-register-link:hover {
        text-decoration: underline;
    }

    @keyframes shake {
        0%, 100% {
            transform: translateX(0);
        }
        10%, 30%, 50%, 70%, 90% {
            transform: translateX(-10px);
        }
        20%, 40%, 60%, 80% {
            transform: translateX(10px);
        }
    }

    .shake-animation {
        animation: shake 0.5s;
    }

    /*四大按钮的字体大小和内边距*/
    .button-large {
        padding: 0.3rem 0.7rem;
        font-size: 0.9rem !important;
    }
    .button-large2{
        padding: 0.3rem 0.7rem;
        font-size: 1rem !important;
    }

    .ZhaiCardPC {
        --bs-gutter-x: 0!important;
    }

    .rr {
        --bs-gutter-x: 1.5rem!important;
    }

    @keyframes shake {
        0%, 100% {
            transform: translateX(0);
        }
        10%, 30%, 50%, 70%, 90% {
            transform: translateX(-2px);
        }
        20%, 40%, 60%, 80% {
            transform: translateX(2px);
        }
    }

    .shake-animation {
        animation: shake 0.5s;
    }

    .hover-hand {
        cursor: pointer;
    }

    /* 调整模态框垂直居中并向上偏移 */
    .modal-dialog-centered {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh; /* 保持模态框在视口中垂直居中 */
    }

    .modal-content {
        margin: auto;
        transform: translateY(-45%); /* 将模态框向上移动20% */
    }
    .feedback-modal {
        width:40%; /* 你可以调整这个百分比以达到你想要的宽度 */
        max-width: 800px; /* 设置最大宽度以避免过宽 */
        margin: auto;
    }
    .upgrade-vip-link {
        color: #00c26f !important;
        font-size: inherit;
        text-decoration: none;
        cursor: pointer;
    }

    .upgrade-vip-link:hover {
        text-decoration: underline;
    }



</style>
